export class LoginWithOtpInitRequestDtoModel {
  email?: string;
  mobileNumber?: string;
  messageTemplate?: string;
  hostName?: string;
}
